import { Link } from 'react-router-dom';

const benefits = [
  {
    icon: 'ri-time-line',
    title: '自由なスケジュール',
    desc: '自分のペースで働ける。週1日〜でもOK',
  },
  {
    icon: 'ri-money-cny-circle-line',
    title: '副業・本業として稼げる',
    desc: '1回€25〜の報酬。人気シッターは月€600以上',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'サポート体制が充実',
    desc: '登録から予約まで日本語でサポート。初心者も安心',
  },
  {
    icon: 'ri-heart-3-line',
    title: 'ペット好きのコミュニティ',
    desc: '同じ価値観を持つ日本人ネットワークで繋がれる',
  },
];

export default function SitterRecruitSection() {
  return (
    <section className="py-16 sm:py-20 md:py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/3]">
              <img
                src="https://public.readdy.ai/ai/img_res/d61a1f567989289c53433a38a80a3dbd.jpg"
                alt="ペットシッターとして活躍する女性"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#81D8D0]/20 to-transparent"></div>
            </div>

            {/* Floating card 1 */}
            <div className="absolute -bottom-4 -right-4 sm:bottom-6 sm:right-6 bg-white rounded-2xl px-4 py-3 flex items-center gap-3 border border-[#EEF4F7]">
              <div className="w-10 h-10 bg-[#D4F0ED] rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-user-star-line text-xl text-[#81D8D0]"></i>
              </div>
              <div>
                <p className="text-xs text-[#1B2A4A]/50">登録シッター数</p>
                <p className="text-base font-black text-[#1B2A4A]">50名以上</p>
              </div>
            </div>

            {/* Floating card 2 */}
            <div className="absolute -top-4 -left-4 sm:top-6 sm:left-6 bg-white rounded-2xl px-4 py-3 flex items-center gap-3 border border-[#EEF4F7]">
              <div className="w-10 h-10 bg-[#D4F0ED] rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-trophy-line text-xl text-[#81D8D0]"></i>
              </div>
              <div>
                <p className="text-xs text-[#1B2A4A]/50">平均評価</p>
                <div className="flex items-center gap-1">
                  <p className="text-base font-black text-[#1B2A4A]">4.9</p>
                  <i className="ri-star-fill text-yellow-400 text-sm"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <p className="text-xs font-semibold text-[#81D8D0] tracking-widest uppercase mb-3">FOR SITTERS</p>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] leading-tight mb-4">
              あなたのペット愛を<br />
              <span className="text-[#81D8D0]">収入に変えよう</span>
            </h2>
            <p className="text-sm sm:text-base text-[#1B2A4A]/60 leading-relaxed mb-8">
              海外在住の日本人として、同じ悩みを持つペットオーナーの力になれます。ペット好きなら経験不問。まずは登録から始めてみましょう。
            </p>

            <ul className="space-y-4 mb-10">
              {benefits.map((b, i) => (
                <li key={i} className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-[#EEF4F7] rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${b.icon} text-lg text-[#81D8D0]`}></i>
                  </div>
                  <div>
                    <p className="text-sm font-bold text-[#1B2A4A] mb-0.5">{b.title}</p>
                    <p className="text-xs text-[#1B2A4A]/55 leading-relaxed">{b.desc}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/sitter-registration"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#81D8D0] text-white font-bold rounded-full hover:bg-[#1B2A4A] transition-all hover:-translate-y-0.5 whitespace-nowrap"
              >
                <i className="ri-user-add-line text-lg"></i>
                シッターとして登録する
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-[#D4E8EC] text-[#1B2A4A] font-semibold rounded-full hover:border-[#81D8D0] hover:text-[#81D8D0] transition-all whitespace-nowrap"
              >
                詳しく見る
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
